import CONFIG from "../config/config";

export function isSupportedLanguage(type?: string): boolean {
    if (!!type) {
        return CONFIG.SUPPORTED_LANGUAGES.filter(lan => lan.code.toLowerCase() === type.toLowerCase()).length > 0;
    }
    return false;
}